import { enhancedApi as generatedApi } from './generated/investigationRecordsRequestsService';

/**
 * Enhanced investigation records requests API with proper file handling for downloads
 * and cache invalidation across related services
 */
export const enhancedInvestigationRecordsRequestsApi =
  generatedApi.enhanceEndpoints({
    addTagTypes: ['police_reports'],
    endpoints: {
      investigationRecordsRequestsGenerateFoiaLetter: {
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/investigation-records-requests/generate-foia-letter/`,
          method: 'GET',
          params: {
            police_report_id: queryArg.policeReportId,
            template_id: queryArg.templateId,
            format: queryArg.format,
          },
          cache: 'no-store',
          responseHandler: (response) => response.blob(),
        }),
      },
      // Enhance send mutations to also invalidate police_reports
      // so automation data gets refreshed
      investigationRecordsRequestsSendCheque: {
        invalidatesTags: ['investigation_records_requests', 'police_reports'],
      },
      investigationRecordsRequestsSendFoiaLetter: {
        invalidatesTags: ['investigation_records_requests', 'police_reports'],
      },
    },
  });

export const { useInvestigationRecordsRequestsGenerateFoiaLetterQuery } =
  enhancedInvestigationRecordsRequestsApi;

// Re-export the enhanced API as the main export
export { enhancedInvestigationRecordsRequestsApi as enhancedApi };
